var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('select',{domProps:{"value":_vm.value},on:{"change":_vm.onChange}},[_c('option',{attrs:{"value":"10"}},[_vm._v("10")]),_vm._v(" "),_c('option',{attrs:{"value":"25"}},[_vm._v("25")]),_vm._v(" "),_c('option',{attrs:{"value":"50"}},[_vm._v("50")]),_vm._v(" "),_c('option',{attrs:{"value":"100"}},[_vm._v("100")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }